export const UPDATE_CHAT_SETTINGS = "UPDATE_CHAT_SETTINGS";
export const SET_CONVERSATION_BREAKERS = "SET_CONVERSATION_BREAKERS";
export const CHANGE_THEME = "CHANGE_THEME";
